import React, { useState } from "react";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const EnquiryFormModal = ({ showEnquiryModal, closeModal }) => {
     // Don't render if modal is closed
    const isLoggedIn = JSON.parse(localStorage.getItem("2xgxgshdugyywerw12gh")) || "";
    const [customerName, setCustomerName] = useState("");
    const [businessName, setBusinessName] = useState("");
    const [address, setAddress] = useState("");
    const [city, setCity] = useState("");
    const [pincode, setPincode] = useState("");
    const [service, setService] = useState("");
    const [notes, setNotes] = useState("");
    const [reminderDate, setReminderDate] = useState("");
    const [reminderTime, setReminderTime] = useState("");
    const [enquirySource, setEnquirySource] = useState("");
    const [customerType, setCustomerType] = useState("new");
    const [mobile, setMobile] = useState("");
    const [email, setEmail] = useState("");



    const handleSubmit = async (e) => {
        e.preventDefault();
       
        try {
            const response = await fetch(`https://100billionoms.com/leads`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    name: customerName,
                    mobile: mobile,
                    business_name: businessName,
                    address: address,
                    city: city,
                    pincode: pincode,
                    related_service: service,
                    remainder_date: reminderDate,
                    remainder_time: reminderTime,
                    type_customer: customerType,
                    remark: notes,
                    age:email,
                    enquiry_source:enquirySource,
                    staff_name:"Admin",
                    user_id:isLoggedIn.user_id
                })
            })
            const res = await response.json();
            if(response.ok){
                toast.success("Thank you!", {
                    position: "top-center",
                    autoClose: 10000, // Close toast after 3 seconds
                });
                closeModal();
            }else{
            toast.error("Please try again!", {
                position: "top-center",
                autoClose: 10000, // Close toast after 3 seconds
            });
        }
        } catch (error) {
            toast.error(`${error}`, {
                position: "top-center",
                autoClose: 10000, // Close toast after 3 seconds
            });
        }
    } 
    if (!showEnquiryModal) return null;

    return (
        <div className="ls-enquiry-modal">
            <div className="ls-enquiry-modal-content">
                <div className="quotation-header">
                    <h2><i className="fa-solid fa-envelope"></i> New Enquiry</h2>
                    <button className="quotation-close" onClick={closeModal}>
                        <i className="fa-solid fa-xmark"></i>
                    </button>
                </div>
                <form onSubmit={handleSubmit}>
                    <div className="ls-form-group">
                        <label>Customer/Business Owner Name</label>
                        <input type="text" name="customerName" placeholder="Enter full name" value={customerName} onChange={(e) => setCustomerName(e.target.value)} />
                    </div>
                    <div className="ls-form-group">
                        <label>Mobile Number*</label>
                        <input
                            type="text"
                            name="mobile"
                            placeholder="Enter mobile number"
                            value={mobile}
                            onChange={(e) => {
                                const value = e.target.value;
                                if (/^\d{0,10}$/.test(value)) { // ✅ Only allows 10 digits (numeric)
                                    setMobile(value);
                                }
                            }}
                            required
                        />
                        {mobile.length > 0 && mobile.length < 10 && (
                            <p style={{ color: "red", fontSize: "12px" }}>Mobile number must be 10 digits</p>
                        )}
                    </div>

                    <div className="ls-form-group">
                        <label>Email</label>
                        <input type="email" name="email" placeholder="Enter email address" value={email} onChange={(e) => setEmail(e.target.value)} />
                    </div>
                    <div className="ls-form-group">
                        <label>Business Name</label>
                        <input type="text" name="businessName" placeholder="Enter business name" value={businessName} onChange={(e) => setBusinessName(e.target.value)} />
                    </div>

                    <div className="ls-form-group">
                        <label>Address</label>
                        <input type="text" name="address" placeholder="Enter address" value={address} onChange={(e) => setAddress(e.target.value)} />
                    </div>

                    <div className="ls-form-row">
                        <div className="ls-form-group">
                            <label>City</label>
                            <input type="text" name="city" placeholder="Enter city" value={city} onChange={(e) => setCity(e.target.value)} />
                        </div>

                        <div className="ls-form-group">
                            <label>Pincode</label>
                            <input
                                type="text"
                                name="pincode"
                                placeholder="Enter pincode"
                                value={pincode}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    if (/^\d{0,6}$/.test(value)) { // ✅ Only allows numbers (0-6 digits)
                                        setPincode(value);
                                    }
                                }}
                                required
                            />

                        </div>

                    </div>

                    <div className="ls-form-group">
                        <label>Required Service</label>
                        <input type="text" name="service" placeholder="What service do you need?" value={service} onChange={(e) => setService(e.target.value)} />
                    </div>

                    <div className="ls-form-group">
                        <label>Add Note</label>
                        <textarea name="notes" placeholder="Additional notes..." value={notes} onChange={(e) => setNotes(e.target.value)}></textarea>
                    </div>

                    <div className="ls-form-row">
                        <div className="ls-form-group">
                            <label>Reminder Date</label>
                            <input type="date" name="reminderDate" value={reminderDate} onChange={(e) => setReminderDate(e.target.value)} />
                        </div>

                        <div className="ls-form-group">
                            <label>Reminder Time</label>
                            <input type="time" name="reminderTime" value={reminderTime} onChange={(e) => setReminderTime(e.target.value)} />
                        </div>
                    </div>

                    <div className="ls-form-group">
                        <label>Enquiry Source</label>
                        <input type="text" name="enquirySource" placeholder="Where did you hear about us?" value={enquirySource} onChange={(e) => setEnquirySource(e.target.value)} />
                    </div>

                    <div className="ls-form-group">
                        <label>Type of Customer</label>
                        <div className="ls-radio-group">
                            <label className={`ls-radio-option ${customerType === "Business" ? "selected" : ""}`} onClick={() => setCustomerType("Business")}>
                                <input type="radio" name="customerType" value="Business" checked={customerType === "new"} readOnly /> Business
                            </label>
                            <label className={`ls-radio-option ${customerType === "Salaried" ? "selected" : ""}`} onClick={() => setCustomerType("Salaried")}>
                                <input type="radio" name="customerType" value="Salaried" checked={customerType === "Salaried"} readOnly /> Salaried
                            </label>
                        </div>
                    </div>





                    <div className="ls-modal-action">
                        <button className="ls-modal-cancel" onClick={closeModal}>Cancel</button>
                        <button className="ls-apply-btn">Submit</button>
                    </div>
                </form>
            </div>
            <ToastContainer />
        </div>
    );
};

export default EnquiryFormModal;
